import iconEvento from '../../../../assets/icons/events/iconEvento.svg';
import iconRecursos from '../../../../assets/icons/iconRecursos.svg';
import iconRA from '../../../../assets/icons/iconRA.svg';

const servicesSections = [
  {
    title: 'Eventos',
    icon: iconEvento,
    description:
      'Inscríbete en talleres deportivos y culturales, conferencias y actividades.',
    url: 'servicios/eventos/inscritos',
    test: 'cmp-btn-eventos-services'
  },
  {
    title: 'Refuerzo Académico',
    icon: iconRecursos,
    description: 'Accede a los talleres y tutorías de tus cursos.',
    url: 'servicios/refuerzo-academico',
    test: 'cmp-btn-ra-services'
  },
  {
    title: 'Recursos',
    icon: iconRA,
    description:
      'Reserva espacios y recursos que necesitas, como computadoras, tablets y más.',
    url: 'servicios/recursos',
    test: 'cmp-btn-recursos-services'
  }
];

const sectionHeader = {
  title: 'Servicios',
  description:
    'Impulsa tu formación con servicios que refuerzan tu aprendizaje y te conectan con actividades culturales, deportivas y académicas.'
};

const subsectionHeader = [
  { id: 1, title: 'Mis cursos' },
  { id: 2, title: 'Record de notas' },
  { id: 3, title: 'Avance de plan de estudio' },
  { id: 4, title: 'Certificaciones progresivas' }
];

export default {
  servicesSections,
  sectionHeader,
  subsectionHeader
};
